// extracted by mini-css-extract-plugin
export default {"role":"Prescribers_role__AxF6c","dateWrapper":"Prescribers_dateWrapper__BWAET"};